import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import useOnOpen from 'hooks/useOnOpen';
import getFirstFocusableElement from '../helpers/getFirstFocusableElement';
const useFocusOnOpen = isOpen => {
  const $ = _c(1);
  const elementRef = useRef();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (elementRef?.current) {
        const firstFocusableElement = getFirstFocusableElement(elementRef.current);
        if (firstFocusableElement) {
          firstFocusableElement.focus();
        }
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useOnOpen(isOpen, t0);
  return elementRef;
};
export default useFocusOnOpen;